import { createI18n } from 'vue-i18n'
import en from '@/locales/en.json'


const dateTimeFormats = {
  'en': {
    short: {
      year: 'numeric', month: 'short', day: 'numeric'
    }
  },
  'ru': {
    short: {
      year: 'numeric', month: 'short', day: 'numeric'
    }
  }
}

export default createI18n({
  legacy: false,
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: { en },
  pluralRules: {
    'ru': function(choice, choicesLength, orgRule) {
      if (choice === 0) {
        return 0
      }
    
      const teen = choice > 10 && choice < 20
      const endsWithOne = choice % 10 === 1
      if (!teen && endsWithOne) {
        return 1
      }
      if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
        return 2
      }
      return choicesLength < 4 ? 2 : 3
    }
  },
  datetimeFormats: dateTimeFormats
})